/**
 * mindChatUiStore — open/close state for the MIND Chat (🧠) panel (1.555.0).
 *
 * Lifted out of MindChatWidget's local `useState` so the trigger can live in the
 * TopBar (next to Help/Settings) instead of a fixed bottom-right FAB. The FAB
 * overlapped the Pi chat composer once the always-on footer + status spinner
 * grew, so the button moved into the top bar; the panel itself still renders
 * from MindChatWidget (mounted in App). Only the open-state moved here.
 */
import { create } from 'zustand';

interface MindChatUiState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const useMindChatUiStore = create<MindChatUiState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
